@if (dataForCard != null) {
  <div>
    @if (dataForCard == null) {
      <div>
        <div class="col-12 kx-b-def-top pt-3 pb-2 pl-0" >
          <div class="kx-no-data kx-crush-txt-100">
            No data found
          </div>
        </div>
      </div>
    }
  </div>
}
<div [ngClass]="bannerFields !=undefined ? bannerFields.className: ''">
  <ng-template #customComponent>
  </ng-template>
</div>
